"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _constant = require("../constant");

var _constants = require("./constants");

var _DiscountTerms = _interopRequireDefault(require("./DiscountTerms.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var TermsWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountTerms__TermsWrapper",
  componentId: "sc-r3mhnb-0"
})(["width:100%;padding:", ";box-sizing:border-box;"], function (_ref) {
  var isModal = _ref.isModal;
  return isModal ? '0 24px 24px' : '24px';
});

var TitleWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountTerms__TitleWrapper",
  componentId: "sc-r3mhnb-1"
})(["border-bottom:1px solid ", ";padding-bottom:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyMedium;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.medium;
});

TitleWrapper.displayName = 'TitleWrapper';

var TermsConditionWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountTerms__TermsConditionWrapper",
  componentId: "sc-r3mhnb-2"
})(["padding-top:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.medium;
});

var PromoCodeWrapper = _styledComponents.default.span.withConfig({
  displayName: "DiscountTerms__PromoCodeWrapper",
  componentId: "sc-r3mhnb-3"
})(["display:inline-block;padding:", ";margin:", ";border-radius:", ";color:", ";background-color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return "1px ".concat(theme.space.micro);
}, function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.space.tiny, " 0");
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.borderRadius.normal;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.secondaryDark;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.backgroundColor.secondaryLight;
});

PromoCodeWrapper.displayName = 'PromoCodeWrapper';

var ValidDateWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountTerms__ValidDateWrapper",
  componentId: "sc-r3mhnb-4"
})(["display:flex;align-items:center;margin:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return "0 0 ".concat(theme.space.tiny, " 0");
});

ValidDateWrapper.displayName = 'ValidDateWrapper';
var TimerIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "DiscountTerms__TimerIcon",
  componentId: "sc-r3mhnb-5"
})(["padding-right:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.xxtiny;
});

var TermsCondition = _styledComponents.default.div.withConfig({
  displayName: "DiscountTerms__TermsCondition",
  componentId: "sc-r3mhnb-6"
})(["padding-bottom:", ";&:last-child{padding-bottom:0;}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.small;
});

var DiscountTerms = function DiscountTerms(_ref13) {
  var accessible = _ref13.accessible,
      theme = _ref13.theme,
      customProperties = _ref13.customProperties,
      data = _ref13.data,
      translation = _ref13.translation,
      isModal = _ref13.isModal,
      isModalOpen = _ref13.isModalOpen,
      isMobile = _ref13.isMobile,
      onCloseModal = _ref13.onCloseModal,
      modalZIndex = _ref13.modalZIndex,
      modalOpacity = _ref13.modalOpacity;
  var description = data.description,
      promoCode = data.promoCode,
      validDate = data.validDate,
      termsCondition = data.termsCondition;

  var _DEFAULT_TRANSLATIONS = _objectSpread(_objectSpread({}, _constants.DEFAULT_TRANSLATIONS), translation),
      title = _DEFAULT_TRANSLATIONS.title,
      validMessage = _DEFAULT_TRANSLATIONS.validMessage;

  var termsAndConditions = (0, _toConsumableArray2.default)(termsCondition);
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var validDateMessage = validDate && validMessage && validMessage.replace('{0}', validDate);

  var getTermsConditionContent = function getTermsConditionContent() {
    return /*#__PURE__*/_react.default.createElement(TermsWrapper, (0, _extends2.default)({
      isModal: isModal
    }, customProperties), data && /*#__PURE__*/_react.default.createElement(TitleWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      display: "block",
      bold: true
    }, title), /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      display: "block",
      type: "small",
      bold: true
    }, /*#__PURE__*/_react.default.createElement(_Theme.default, {
      theme: "AIRASIA_CLASSIC"
    }, /*#__PURE__*/_react.default.createElement(PromoCodeWrapper, null, promoCode))), /*#__PURE__*/_react.default.createElement(ValidDateWrapper, null, /*#__PURE__*/_react.default.createElement(TimerIcon, {
      color: "greyDark",
      fontsize: "normal",
      icon: "TimerIcon"
    }), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "greyDark",
      theme: theme,
      display: "block",
      type: "small"
    }, validDateMessage)), /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      display: "block",
      type: "small"
    }, description)), data && /*#__PURE__*/_react.default.createElement(TermsConditionWrapper, null, termsAndConditions && termsAndConditions.length > 0 && termsAndConditions.map(function (term, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react.default.createElement(TermsCondition, {
          key: "discount-terms-condition-".concat(index)
        }, /*#__PURE__*/_react.default.createElement(_Text.default, {
          theme: theme,
          display: "block",
          type: "small"
        }, term.title), /*#__PURE__*/_react.default.createElement(_Text.default, {
          theme: theme,
          display: "block",
          type: "small"
        }, term.content))
      );
    })));
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isModal ? getTermsConditionContent() : /*#__PURE__*/_react.default.createElement(_Modal.default, {
      accessible: accessible,
      backgroundColor: "default",
      openModal: isModalOpen,
      overlayBackgroundColor: "black",
      overlayOpacity: modalOpacity,
      theme: theme,
      fullScreen: isMobile,
      viewPort: isMobile ? _constant.DEVICE_TYPE.MOBILE : _constant.DEVICE_TYPE.DESKTOP,
      zIndex: modalZIndex,
      onClose: onCloseModal
    }, getTermsConditionContent()));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

DiscountTerms.propTypes = _DiscountTerms.default.PropTypes;
DiscountTerms.defaultProps = _DiscountTerms.default.DefaultProps;
var _default = DiscountTerms;
exports.default = _default;